<template>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-3">
        <div class="card card_item">
            <div v-if="langSelected > -1" class="card_item--video" @mouseenter="showVideoFrame" @mouseleave="hideVideoFrame" style="cursor: pointer;">
                <div v-show="!isHovered" :id="`campaign-thumbnail-image-${campaign['videos'][langSelected].vidId}`"
                     class="positioned-overlay">
                    <figure class="item_img" :style="{ backgroundImage: `url(${pathImagenVideo})` }">
                        <div class="container-loader dp_none" :id="`lo${campaign['videos'][langSelected].vidId}`">
                            <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
                                <circle class="circle-loader" cx="170" cy="170" r="160" stroke="#3ccfd1"/>
                                <circle class="circle-loader" cx="170" cy="170" r="135" stroke="#dbdde0"/>
                                <circle class="circle-loader" cx="170" cy="170" r="110" stroke="#3ccfd1"/>
                                <circle class="circle-loader" cx="170" cy="170" r="85" stroke="#dbdde0"/>
                            </svg>
                        </div>
                    </figure>

                    <div class="container-campaign-play-button">
                        <a :id="`playVideo${campaign['videos'][langSelected].vidId}`"
                           :href="`${urlVideo()}`" target="_blank" class="play-icon play-size-md show-play">
                        </a>
                    </div>
                </div>
                <div v-show="isHovered" @click="goToVideo"
                     :id="`campaign-thumbnail-video-${campaign['videos'][langSelected].vidId}`"
                     class="positioned-overlay">
                    <video-miniature-player
                        ref="videoPlayer"
                        :videoFilterOptions="videoFilterOptions"
                        :video_layout_class="video_layout_class"
                        @player-ready="autoPlay"
                        v-if="!isFetching"/>
                </div>
            </div>
            <div v-else class="card_item--video">
                <figure class="item_img" :style="{ backgroundImage: `url(${pathImagenVideo.value})` }">
                </figure>
            </div>
            <div class="card-body card_body--item">
                <figure>
                    <figcaption class="text-dark pb-3">
                        <div class="row">
                            <div class="col-12 mr-auto box_info--audio">
                                <h3 class="s_15 fw-bold text-truncate">{{ campaign['videos'][langSelected].title }}</h3>
                            </div>
                        </div>
                    </figcaption>
                </figure>
            </div>
            <div class="card-footer border-0 bg-white pt-0">
                <div class="d-flex align-items-center mb-2 w-100"
                     :class="{'pull-right': langSelected > -1}">
                    <div class="d-flex align-items-center">
                        <div v-if="hasLanguages == true" class="dropdown">
                            <a :id="`selectLang${identifier}`" role="button"
                               class="btn btn-language-campaign btn_full py-1 ps-2 pe-5 btn_line fw-bold text-capitalize"
                               data-bs-toggle="dropdown">
                                <span v-if="langSelected > -1">{{ translate(campaign['videos'][langSelected].langDesc) }}</span>
                            </a>
                            <ul class="dropdown-menu text-capitalize" aria-labelledby="optionsBar">
                                <li class="dropdown-item languages d-flex align-items-center"
                                    v-for="(item, index) in campaign['videos']"
                                    :key="index"
                                    @click="selectLanguage(index)">
                                    {{ translate(item.langDesc) }}
                                    <div v-if="item.isMultiCampaign > 0" class="container-icon-multicampaign mini-size ms-1">
                                        <img src="/build/images/img_fe_v2m/svg/multicampaign-2.svg" title="Multicampaign" width="12"
                                             height="12" alt="Multicampaign">
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <a :id="`selectLang${identifier}`"
                               class="btn btn-language-campaign no-dropdown btn_full py-1 ps-2 pe-5 btn_line fw-bold text-capitalize">
                                <span v-if="langSelected > -1">{{ translate(campaign['videos'][langSelected].langDesc) }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref, computed, onBeforeMount, onMounted} from 'vue';
import VideoMiniaturePlayer from "@/playerVue3/components/video-miniature-player";
import { useTranslation } from "@/composables/useTranslation";
import { usePortfolioStore } from "../storage/storePortfolio";

const { translate } = useTranslation();
const portfolioStore = usePortfolioStore();

const props = defineProps({
    identifier: {
        type: Number,
        required: true,
    },
    campaign: {
        type: Object,
        required: true,
    },
});

const videoPlayer = ref(null);
const folderUpload = ref('');
const hasLanguages = ref(false);
const langSelected = ref(0);
const isHovered = ref(false);
const isFetching = ref(true);
const autoPlay = ref(true);
const video_layout_class = ref('video-layout-horizontal');
const videoFilterOptions = ref({
    vid: 0,
    wid: 0,
    email: '',
});

const pathImagenVideo = computed(() => {
    if (langSelected.value > -1 && props.campaign.videos[langSelected.value].thumbnailImage) {
        return folderUpload.value + 'videos/images/' + props.campaign.videos[langSelected.value].thumbnailImage;
    } else {
        for (let i = 0; i < props.campaign.videos.length; i++) {
            if (props.campaign.videos[i].thumbnailImage) {
                return folderUpload.value + 'videos/images/' + props.campaign.videos[i].thumbnailImage;
            }
        }
        return folderUpload.value + 'videos/images/not-available.jpg';
    }
});

function hideVideoFrame() {
    pauseChildVideo();
    isHovered.value = false;
}

function pauseChildVideo() {
    if (videoPlayer.value && typeof videoPlayer.value.pauseVideo === 'function') {
        videoPlayer.value.pauseVideo();
    }
}

function playChildVideo() {
    if (videoPlayer.value && typeof videoPlayer.value.playVideo === 'function') {
        videoPlayer.value.playVideo();
    }
}

function selectLanguage(value) {
    langSelected.value = value;
}

function showVideoFrame() {
    const dataVideo = props.campaign.videos[langSelected.value];
    videoFilterOptions.value.vid = parseInt(dataVideo.vidId);
    videoFilterOptions.value.wid = parseInt(dataVideo.weblink_id);
    videoFilterOptions.value.email = '';

    isFetching.value = false;
    isHovered.value = true;
    playChildVideo();
}

function goToVideo() {
    const url = urlVideo()
    window.open(url, '_blank');
}

function urlVideo(typeView = 'video') {
    if (langSelected.value > -1) {
        let domainVideo = props.campaign['videos'][langSelected.value]['customDomainCompany'] || portfolioStore.getSiteUrl;

        let iframeParameter = typeView == 'iframe' ? '?iframe=true' : ''
        return domainVideo + '/campaign/video/' + props.campaign['videos'][langSelected.value].encID + iframeParameter
    }
    return ''
}

onBeforeMount(() => {
    folderUpload.value = $('#folderUpload').val();
});

onMounted( () => {
    if (props.campaign && props.campaign.videos.length > 1 && props.campaign.videos[0].langDesc) {
        hasLanguages.value = true;
    }
});
</script>
